// Staff get the app; someone outside InRange gets only the pages shared with them. What the
// pages themselves need (the sent-comment notice) is provided here, for both.
import { useContext } from "react";

import { UserContext } from "../auth";
import { SentNoticeProvider } from "../state/SentNoticeContext";
import { AppLayout } from "./AppLayout";
import { ExternalLayout } from "./ExternalLayout";

export const RootLayout = () => {
  const external = useContext(UserContext).role === "external";
  return <SentNoticeProvider>{external ? <ExternalLayout /> : <AppLayout />}</SentNoticeProvider>;
};
